export default function (total, rank) {
	return Math.floor((rank * 100) / (total));
}